import React, { useState } from 'react'
import { Card, Container, Form, InputGroup } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { Circles } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { CLIENT_SECRET, getSvgIcon, EMPTY_ARRAY } from '../../../constants/globalConstants'
import { userSingIn, userSingUp } from '../../../redux/actions/singinAndSingUp'
import ConfirmationTerms from '../../../global/ConfirmationTerms'
import MiniHeader from '../MiniHeader'
import { getConfigDetails } from '../../../services/config'
import { errorMessage } from '../../../constants/errorMessage'
import { useEffect } from 'react'
import NoData from '../../NoData'
import { getFirstErrorMessage, getRootDomain, restrictInValidCharPassword, validatePassword } from '../../../utils/helper'
import { getPartnerDetailsBySLug } from '../../../redux/actions/userDetails'
import CONSTANTS from '../../../redux/constants'
import { addEventLog } from '../../../redux/actions/EventsLog'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
require('./singup.scss')

function Singup(props) {
    const { dispatch, loader, notify, isFetching } = props
    const [isValidPartner, setIsValidPartner] = useState(false)

    let partner = window.location.toString().split('/')[3]
    const { register, handleSubmit, control, formState: { errors }, reset, watch, setFocus, setValue } = useForm()
    const navigate = useNavigate()

    const domain = getRootDomain()

    useEffect(() => {
        setFocus('fullName')
    }, [setFocus])

    useEffect(() => {
        if (partner) {
            const history = JSON.parse(localStorage.getItem('history'))
            if(history?.route == 'h'){
                partner = `${partner}?qrCode=${history?.facility}`
            }
            if(domain && (domain.includes('parkpayride') || domain.includes('park2visit'))){
                partner = `${partner}?domain=${domain}`
            }
            dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
                if (res?.data?.email) {
                    setIsValidPartner(true)
                    localStorage.removeItem('partnerData')
                    localStorage.setItem('partnerData', JSON.stringify(res?.data))
                    const partnerData = res?.data
                    const color = partnerData?.brand_setting?.color
                    const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                    if (color) {
                        document.documentElement.style.setProperty('--bs-primary', color)
                        document.documentElement.style.setProperty('base-color', color)
                        document.documentElement.style.setProperty('primary', color)
                        document.documentElement.style.setProperty('textcolor', color)
                        document.documentElement.style.setProperty('--bs-btn-bg', color)
                        document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                        document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                        document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                        document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
                    }

                } else {
                    setIsValidPartner(false)
                    localStorage.removeItem('partnerData')
                }
            })
        }

    }, [EMPTY_ARRAY])

    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [termsModalOpen, setTermsModalOpen] = useState(false)
    const [error, setError] = useState({ password_strength: false, confirm_password_strength: false })


    useEffect(() => {
        setFocus('fullName')
    }, [setFocus])

    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') { setPasswordShown(passwordShown ? false : true) }
        if (key === 'mpassword') { setMPasswordShown(mpasswordShown ? false : true) }
        if (key === 'cpassword') { setCPasswordShown(cpasswordShown ? false : true) }
    }

    const redirecttoLogin = () => {
        navigate(`/${partner}/login`)
    }

    const onSignUp = (data) => {
        if (!validatePassword(data?.password)) {
            setError({ ...error, password_strength: true })
            return
        } else if (!validatePassword(data?.confirm_password)) {
            setError({ ...error, confirm_password_strength: true })
            return
        }
        const pushBack = JSON.parse(localStorage.getItem('history'))
        if (data?.termsAndCond) {
            if (data?.confirm_password === data?.password) {
                const payload = {
                    'first_name': data?.fullName,
                    'last_name': '',
                    'email': data?.email,
                    'phone': data?.phone,
                    'confirm_password': data?.confirm_password,
                    'client_secret': CLIENT_SECRET,
                    'base_url': `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revtransientURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.pcitransientURL : getConfigDetails()?.transientURL}/${partner}/${pushBack?.route ? pushBack?.route : 'touchless-parking'}/${pushBack?.facility}`
                }
                dispatch(userSingUp(payload)).then((res) => {
                    if (res?.status === 201) {
                        localStorage?.setItem('sign_up', JSON.stringify(res?.data))
                        const signInPayload = {
                            client_id: getConfigDetails()?.CLIENT_ID,
                            client_secret: getConfigDetails()?.CLIENT_SECRET,
                            grant_type: 'password',
                            username: data?.email,
                            password: data?.confirm_password
                        }
                        dispatch(userSingIn(signInPayload)).then((res) => {
                            if (res?.status === 201 && res?.data !== null) {
                                localStorage?.setItem('sign_in', JSON.stringify(res?.data))
                                notify('success', 'Registration Successfully Completed')
                                reset(formValues => ({
                                    ...formValues,
                                    'first_name': '',
                                    'last_name': '',
                                    'email': '',
                                    'phone': '',
                                    'confirm_password': '',
                                    'client_secret': CLIENT_SECRET
                                }))
                                // navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
                                if(pushBack?.route && pushBack?.facility){
                                    navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
                                }else{
                                    navigate(`/${partner}`)
                                }
                                // navigate(0)
                            } else {
                                navigate(`/${partner}/login`)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.registeration)
                            }
                        }).catch((err) => {
                            let errObject = { 
                                payload: signInPayload,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} userSingIn-singup.js-257`))
                            navigate(`/${partner}/login`)
                            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.registeration)
                        })
                    } else {
                        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((err) => {
                    let errObject = { 
                        payload: payload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} userSingIn-singup.js-257`))
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            } else {
                notify('error', 'Password not match')
            }
        } else {
            setTermsModalOpen(true)
        }
    }

    return (
        isFetching ? null : isValidPartner ? <div>
            <MiniHeader isDisplayBack title="CREATE ACCOUNT" />
            <Container className='signupmain mt-2'>
                {/* <h5 className='mt-3 text-info'>Create Account</h5>
                <hr className='singHeaderBorder' /> */}
                <p className='singtextInfo'>Unlock the best price and become an insider for our exclusive launches and offer</p>
            </Container>

            <Form onSubmit={handleSubmit(onSignUp)}>
                <Container>
                    <label className='form-label'>Your Information <span className="text-danger me-1">*</span></label>
                    <Card>
                        <InputGroup>
                            <InputGroup.Text id="inputLoginImage"><span style={{ height: '25px', width: '22px' }}>{getSvgIcon('USER', 'var(--bs-primary)')}</span></InputGroup.Text>
                            <Form.Control type="text" name='fullName' aria-describedby="basic-addon1" className='form-control inputLogin' id='fullName' maxLength='40' minLength='1' placeholder="Full Name"   {...register('fullName', { required: { value: true, message: 'Full Name field is required' }, })} />
                        </InputGroup>
                        <InputGroup className='inputBorderUpper'>
                            <InputGroup.Text id="inputLoginImage"><span style={{ height: '25px', width: '22px' }}>{getSvgIcon('Email', 'var(--bs-primary)')}</span></InputGroup.Text>
                            <Form.Control type="email" name='email' aria-describedby="basic-addon1" className='form-control inputLogin' id='email' maxLength='40' minLength='1' placeholder="Enter Email Address" {...register('email', {
                                required: { value: true, message: 'Email field is required' },
                                pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'invalid email address' },
                            })} />
                        </InputGroup>
                        <InputGroup className='inputBorderUpper'>
                            <InputGroup.Text className='mapFlagImage'><span style={{ height: '25px', width: '25px' }}>{getSvgIcon('Country', 'var(--bs-primary)')}</span>+1</InputGroup.Text>
                            <Controller
                                name="phone"
                                type="text"
                                id="phone"
                                control={control}
                                inputMode="numeric"
                                defaultValue=''
                                autoFocus={false}
                                rules={{
                                    required: { value: true, message: 'Phone field is Required' },
                                    minLength: { value: 10, message: 'Please enter a valid number' },
                                    maxLength: { value: 14, message: 'Please enter a valid number' }
                                }}
                                render={({ field }) => <MaskedInput
                                    maskGenerator={phoneMaskGenerator}
                                    className="form-control inputLogin"
                                    {...field}
                                    id="loginInputSingup"
                                    maxLength={14}
                                    inputMode="numeric"
                                    title="Please enter a valid phone number"
                                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                    onInput={e => e.target.setCustomValidity('')}
                                    placeholder="(123)-555-1234"
                                />
                                }
                            />
                            {/* <Form.Control type="text" name='phone' aria-describedby="basic-addon1" className='form-control inputLogin' id='loginInputSingup' maxLength='40' minLength='1' placeholder="Phone Number" {...register('phone', { required: true })} /> */}
                        </InputGroup>
                    </Card>

                    {getFirstErrorMessage(['fullName', 'email', 'phone'], errors) && (
                        <span style={{ color: 'red', fontSize: '13px' }}>
                            {getFirstErrorMessage(['fullName', 'email', 'phone'], errors)}
                        </span>
                    )}

                    <label htmlFor="exampleInputPassword1" className="form-label my-1 d-block">Set Your Password <span className="text-danger me-1">*</span>
                        <span className="popoverSection position-relative" >
                            <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                            <i className="fa fa-question-circle " />
                        </span>
                    </label>
                    <Card>
                        <InputGroup className='myiconset'>
                            <InputGroup.Text id="inputLoginImage"><span style={{ height: '22px', width: '22px' }}>{getSvgIcon('Password', 'var(--bs-primary)')}</span></InputGroup.Text>
                            <Form.Control
                                type={passwordShown ? 'text' : 'password'}
                                name='password'
                                className="form-control passwordInput inputLogin"
                                id="password"
                                placeholder="Enter Password"
                                aria-describedby="basic-addon1"
                                {...register('password', {
                                    required: { value: true, message: 'Password is required' },
                                    pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-])[^()\\`~:;"/<>]{8,15}$/, message: 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' },
                                    onChange: (e) => setValue(e.target.name, restrictInValidCharPassword(e.target.value))
                                })}
                            />
                            <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                        </InputGroup>
                        <InputGroup className='inputBorderUpper myiconset'>
                            <InputGroup.Text id="inputLoginImage"><span style={{ height: '22px', width: '22px' }}>{getSvgIcon('Password', 'var(--bs-primary)')}</span></InputGroup.Text>
                            <Form.Control
                                type={cpasswordShown ? 'text' : 'password'}
                                name='confirm_password'
                                className="form-control passwordInput inputLogin"
                                id="confirm_password"
                                placeholder="Confirm Password"
                                aria-describedby="basic-addon1"
                                {...register('confirm_password', {
                                    required: { value: true, message: 'Confirm Password is required' },
                                    pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-])[^()\\`~:;"/<>]{8,15}$/, message: 'Confirm Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' },
                                    validate: (val) => {
                                        if (watch('password') != val) {
                                            return 'Your passwords does not match'
                                        }
                                    },
                                    onChange: (e) => setValue(e.target.name, restrictInValidCharPassword(e.target.value))
                                })}
                            />
                            <i className={cpasswordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                        </InputGroup>
                    </Card>
                    {getFirstErrorMessage(['password', 'confirm_password'], errors) && (
                        <span style={{ color: 'red', fontSize: '13px' }}>
                            {getFirstErrorMessage(['password', 'confirm_password'], errors)}
                        </span>
                    )}

                </Container>

                <Container className='mt-4 checkboxfortheSingup'>
                    <div className="">
                        <input className="mb-3 form-check-input" name='termsAndCond' type="checkbox" id="formHorizontalCheck"  {...register('termsAndCond')} />
                        <label className='checkboxSingup form-check-label' >I agree to Terms of Services and Privacy Policy</label>
                    </div>
                </Container>

                <Container className="mt-3">
                    <button type="submit" name="submit" disabled={loader} className="btn w-100 my-4 text-white bg-primary">
                        <div className='d-flex justify-content-center align-items-center'>
                            <span>Create Account </span>  <span className='ms-2'>
                                {(loader) ? <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="#ffffff"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /> : null}
                            </span>
                        </div>
                    </button>
                </Container>

                <Container className='signupmain'>
                    <p className='AlreadyAccount'>Already have a account ? <span className='loginAccountAlredy' onClick={redirecttoLogin}>Login</span></p>
                </Container>
            </Form>



            <ConfirmationTerms
                isConfimationModalOpen={termsModalOpen}
                setIsConfimationModalOpen={setTermsModalOpen}
                Message='Please accept Terms of Services and Privacy Policy'
                cancleButtonColor='text-primary'
                cancelButton={true}
                cancelButtonLabel='OK'
            />
        </div> : <NoData message={errorMessage?.invalidPartner} />
    )
}

Singup.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
    isFetching: PropTypes.bool,
}

Singup.defaulProps = {
    dispatch: noop,
    loader: false,
    notify: noop,
    isFetching: true,
}

function mapStateToProps({ singInAndSingUp, userDetailsReducer }) {
    return {
        loader: singInAndSingUp?.loader,
        isFetching: userDetailsReducer?.isFetching,
    }
}
export default connect(mapStateToProps)(Singup)